import { useEffect } from "react";
import usePathTmp from "./path/usePathTmp";
import useCamera from "./useCamera";
import useBlockMove from "./block/useBlockMove";
import useBlockSelection from "./block/useBlockSelection";
import editorAction from "../actions/editorAction";
import BlockContainerAction from "../actions/blockContainerAction";
import useActionKey from "./useActionKey";

// Main component of the hook editor, this components required a lot of third party hooks and will be re-render often
function useBlockManager () {

    const { movePathTmp, deletePathTmp, pathTmp, magnetPosition, mouse } = usePathTmp();

    const { blocksSelected, zoneSelectBlocks, makeZoneSelection, updateZoneSelection, resetZoneSelection, blockIdClicked } = useBlockSelection();
    
    const { moveBlocks } = useBlockMove();

    const { pressDown, ctrlKey, onClickDown, onClickUp ,onKeyDown , onKeyUp, changeShiftKey, shiftKey  } = useActionKey();

    const { panzone, getPosition } = useCamera();

    const { deleteAllSelectedBlock } = BlockContainerAction();

    const { updateBlocksPosition, updateCategory } = editorAction();


    // Those constant can be calculate in another place if needeed, their some condition who will be useful in the different function of this hook
    const isZoneSelectBlockActive = zoneSelectBlocks.x != 0 && zoneSelectBlocks.y != 0;

    const isZoneSelectBlockDesactive = zoneSelectBlocks.x == 0 && zoneSelectBlocks.y == 0;

    const isMousePositionNotSet = mouse.x != 0 && mouse.y != 0;

    const mouseMove = (e) => {
        
        if(pathTmp) {
            panzone.pause();
            const { scale } = getPosition();
            movePathTmp(e.clientX, e.clientY, scale);
            return;
        }
        if(shiftKey == true && ctrlKey == true && pressDown && (e.target.classList.contains('camera') || e.target.classList.contains('category_container')) && isZoneSelectBlockDesactive) {
            panzone.pause();
            makeZoneSelection(e.clientX, e.clientY);
            return;
        }
        
        if(shiftKey == true && ctrlKey == true && pressDown && isZoneSelectBlockActive) {
            panzone.pause();
            updateZoneSelection(e.clientX, e.clientY, getPosition());
            return;
        }
        
        if( e?.target?.classList?.contains('camera') && isZoneSelectBlockActive && (ctrlKey == false || pressDown == false) ) {
            resetZoneSelection();
            return;
        }

        if(blocksSelected.length > 1 && shiftKey == false) {
            deleteAllSelectedBlock();
            return;
        }

        if(shiftKey == true && blocksSelected.find(block => block.id == blockIdClicked) == undefined) {            
            return;
        }

        if(isMousePositionNotSet && pressDown) {
            panzone.pause();
            const { scale } = getPosition();
            moveBlocks(blocksSelected, e.clientX, e.clientY, scale);
            return;
        }
    }

    const mouseUp = async (e) => {
        
        // Check if click inside camera
        if(handleClick(e) == false) {
            return;
        }

        // check click
        if(onClickUp(e) == false) return;

        // check if camera instance exist for resume her (it's means user cannot move the camera until unlock)
        if(panzone) panzone.resume(); 

        // check if some block have been selected
        if(blocksSelected.length == 0) return;

        // if multiple selection is enabled then we continue our path
        if(isMousePositionNotSet == false) {
            return;
        }
        
        // To get to this point it's means a block have been selected, moved and now the user is realeased him
        const blocksPosition = [];
        blocksSelected.map( data => {
            const { block, id } = data;
            // Fix quick resume mouse who lead to unexpected bug can be cause if the user use to often the multiple select option
            if(block._x != undefined && block._y != undefined) {
                blocksPosition.push({ object_id : block.object_id, x : block._x, y : block._y})
            }
            
            var block_dom = document.getElementById(id);
            if(block_dom) document.getElementById(id).classList.remove("grabbed");
            // Fix for custom class css, more effient and performant than a hook
            //document.getElementById(id).classList.remove("selected");
        });

        // If some blockPosition have been find then we update their position in the global state of the tree
        if(blocksPosition.length) {
            await updateBlocksPosition(blocksPosition)
            let category_ids = blocksSelected.map( element => element.block.bot_category_id).filter(block=>block);
            if (category_ids.length == 0) return;
            updateCategory(category_ids);
        }

        // Just in case released all the block selected trought the state editor
        
    }

    const onClick = (e) => {
        if(handleClick(e) == false || pathTmp == null) {
            return;
        } 
        // If a click is inside the camera and the pathTmp is created we try to delete it, if the click if outside some composent
        // See deletePathTmp for implementation
        deletePathTmp(e.target.classList);
    }

    const handleClick = (e) => {
        const element = document.querySelector('.camera')
        return element?.contains(e.target);
    }
    
    // Bind all the method defined in the hook on the body
    useEffect(() => {
        
        document.body.onmouseup = (e) => {
            mouseUp(e);
            // A middeware for reset the multiple select zone of the bot
            if(zoneSelectBlocks.x != 0 && zoneSelectBlocks.y != 0) {
                resetZoneSelection();
            }
        }
        document.body.onmousemove = mouseMove;
        document.body.onclick = onClick;
        document.body.onmousedown = (e) => {
            // A middeware to check if the click occured in the camera element, if no return (very useful, if missing then onmousedown will be trigger evrywhere, leak to a lof of issues)
            if(handleClick(e) == false) {
                return
            }
            onClickDown(e)
        }
        document.body.onkeydown = (e) => {
            onKeyDown(e);
            if(ctrlKey == shiftKey && shiftKey) return;
            if(e.shiftKey == false) return;
            changeShiftKey();
            
            //else if(!e.shiftKey && e.shiftKey != shiftKey) return;
            //changeShiftKey();
        }
        document.body.onkeyup = (e) => {
            onKeyUp(e);
            // A middeware for reset the multiple select zone of the bot
            if(e.ctrlKey == false && zoneSelectBlocks.x != 0 && zoneSelectBlocks.y != 0) {
                resetZoneSelection();
            }
            //if(e.shiftKey == true) return;
            //changeShiftKey()
        }

        // 👇️ remove event listener when the component unmounts
        return () => {
            document.body.onmouseup = () => {};
            document.body.onmousemove = () => {};
            document.body.onclick = () => {};
            document.body.onmousedown  = () => {};
            document.body.onkeydown = () => {}
            document.body.onkeyup = () => {}
        };
        // Lot of depencies stuff : remember if you use don't pass global param who are used in the method in the depencies array, their values will never be updated
    }, [blocksSelected, pathTmp, magnetPosition, ctrlKey, pressDown, zoneSelectBlocks, shiftKey]);

    return null;
}

export default useBlockManager;